import React, { Component } from 'react'
import { Menu, Divider } from 'antd'
import { autoGenKey } from '../../../lib/helper'

const { SubMenu } = Menu

const hasIgnorePermission = ele =>
    !!(ele && ele.props && ele.props.ignore_permission)

const toChildrenArray = node => React.Children.toArray(node).filter(Boolean)

const hasIgnorePermissionInChildProps = ele =>
    !!(
        ele &&
        ele.props &&
        ele.props.children &&
        ele.props.children.props &&
        ele.props.children.props.ignore_permission
    )

const checkMenuVisibility = (list, permissions) => {
    //   console.log('list permissions', permissions)
    //   console.log('list ', list)
    // Special marker: allow showing submenu even if permission is not present.
    if (Array.isArray(list) && list.includes('__always__')) return false

    if (
        typeof permissions == 'undefined' ||
        typeof permissions == 'string' ||
        permissions == []
    )
        return true

    let hideMenu = true
    for (let i = 0; i < list.length; i++) {
        let menu = list[i]

        let canAccess = permissions.find(ele => {
            return ele.matching_name == menu && ele.can_view == 1
        })

        if (typeof canAccess != 'undefined') {
            hideMenu = false
        }
    }

    return hideMenu
}

export class AutorizeMenu extends Component {
    render() {
        let { permissions, children } = this.props
        // console.log('childrenchildren', children)
        let haveChild = false
        let isSubmenu = false
        const createExternalMenu =
            typeof this.props.createExternalMenu === 'function'
                ? this.props.createExternalMenu
                : null

        const childrenArr = toChildrenArray(children)
        // If AutorizeMenu was given a single Menu.Item, treat it as submenu wrapper.
        if (
            childrenArr.length === 1 &&
            childrenArr[0] &&
            childrenArr[0].type &&
            typeof childrenArr[0].type.isMenuItem != 'undefined' &&
            childrenArr[0].type.isMenuItem
        ) {
            isSubmenu = true
        }

        // Keep original semantics: treat as "haveChild" only when a direct child has
        // an ARRAY of children (i.e., Menu.SubMenu with multiple Menu.Item).
        childrenArr.forEach(ele => {
            if (!ele || !ele.props) return
            if (Array.isArray(ele.props.children)) haveChild = true
        })

        // normalize for existing logic below
        children = childrenArr

        if (!haveChild && !isSubmenu) {
            return (
                <Menu
                    mode="inline"
                    onClick={({ item, key, keyPath, selectedKeys, domEvent }) => {
                        this.props.handleActiveMenu(item.props.matching_name)
                    }}
                    openKeys={this.props.openKeysMenu}
                    onOpenChange={this.props.handleonOpenChange}
                >
                    <SubMenu
                        className="ant-menu-submenu-focus"
                        popupClassName="popup-menu-custom scroll-style"
                        style={{
                            display:
                                checkMenuVisibility(
                                    //   children.map(ele => ele.props.matching_name),

                                    children.map(ele => {
                                        if (hasIgnorePermission(ele)) return '__always__'
                                        if (
                                            ele.props.web_use != 'undefined' &&
                                            ele.props.web_use != '' &&
                                            ele.props.web_use == ele.props.web_endpoint
                                        ) {
                                            return ele.props.matching_name
                                        } else if (
                                            ele.props.web_use != 'undefined' &&
                                            ele.props.web_use == ''
                                        ) {
                                            return ele.props.matching_name
                                        } else {
                                            return ''
                                        }
                                    }),
                                    permissions,
                                ) && 'none',
                        }}
                        key={this.props.subkey}
                        title={this.props.title}
                    >
                        {children.filter(ele => {
                            if (hasIgnorePermission(ele)) return true
                            let menu = ele.props.matching_name
                            let canAccess = null
                            if (
                                ele.props.web_use != 'undefined' &&
                                ele.props.web_use != '' &&
                                ele.props.web_use == ele.props.web_endpoint
                            ) {
                                canAccess = permissions.find(ele => {
                                    return ele.matching_name == menu && ele.can_view == 1
                                })
                            } else if (
                                ele.props.web_use != 'undefined' &&
                                ele.props.web_use == ''
                            ) {
                                canAccess = permissions.find(ele => {
                                    return ele.matching_name == menu && ele.can_view == 1
                                })
                            }
                            return canAccess
                        })}
                        {createExternalMenu
                            ? createExternalMenu(permissions, this.props.menu_hierarchy || '')
                            : null}
                    </SubMenu>
                </Menu>
            )
        } else {
            let resultArr = []
            children.forEach(ele => {
                const hasArrayChildren = !!(
                    ele &&
                    ele.props &&
                    Array.isArray(ele.props.children) &&
                    ele.props.children.length > 0
                )

                if (hasArrayChildren) {
                    let result = ele.props.children.map(ele1 => {
                        if (!ele1 || !ele1.props) return undefined
                        if (hasIgnorePermission(ele1)) return '__always__'
                        if (
                            ele1.props.web_use != 'undefined' &&
                            ele1.props.web_use != '' &&
                            ele1.props.web_use == ele1.props.web_endpoint
                        ) {
                            return ele1.props.matching_name
                        } else if (
                            ele1.props.web_use != 'undefined' &&
                            ele1.props.web_use == ''
                        ) {
                            return ele1.props.matching_name
                        }
                    })
                    result.map(ele => {
                        if (typeof ele != 'undefined') {
                            resultArr.push(ele)
                        }
                    })
                } else {
                    if (
                        ele &&
                        ele.props &&
                        ele.props.children &&
                        ele.props.children.type &&
                        typeof ele.props.children.type.isMenuItem != 'undefined' &&
                        ele.props.children.type.isMenuItem
                    ) {
                        if (hasIgnorePermissionInChildProps(ele)) {
                            resultArr.push('__always__')
                            return
                        }
                        if (
                            typeof ele.props.children.props.web_use != 'undefined' &&
                            ele.props.children.props.web_use != '' &&
                            ele.props.children.props.web_use ==
                            ele.props.children.props.web_endpoint
                        ) {
                        } else if (
                            typeof ele.props.children.props.web_use != 'undefined' &&
                            ele.props.children.props.web_use == ''
                        ) {
                            resultArr.push(ele.props.children.props.matching_name)
                        }
                    } else {
                        if (hasIgnorePermission(ele)) {
                            resultArr.push('__always__')
                            return
                        }
                        if (
                            typeof ele.props.web_use != 'undefined' &&
                            ele.props.web_use != '' &&
                            ele.props.web_use == ele.props.web_endpoint
                        ) {
                            resultArr.push(ele.props.matching_name)
                        } else if (
                            typeof ele.props.web_use != 'undefined' &&
                            ele.props.web_use == ''
                        ) {
                            resultArr.push(ele.props.matching_name)
                        }
                    }
                }
            })

            let resultChildren = children.filter(ele => {
                if (!ele || !ele.props) return false
                let subChildren = ele.props.children
                let subChildrenArr
                if (Array.isArray(subChildren)) {
                    subChildrenArr = subChildren
                } else if (
                    subChildren &&
                    subChildren.type &&
                    typeof subChildren.type.isMenuItem != 'undefined' &&
                    subChildren.type.isMenuItem
                ) {
                    subChildrenArr = [subChildren]
                } else {
                    subChildrenArr = [ele]
                }
                let res = false

                subChildrenArr.forEach(ele1 => {
                    if (!ele1 || !ele1.props) return
                    if (hasIgnorePermission(ele1)) {
                        res = true
                        return
                    }
                    let canAccess = false

                    permissions.forEach(ele2 => {
                        if (
                            ele2.matching_name == ele1.props.matching_name &&
                            ele2.can_view == 1
                        ) {
                            if (
                                typeof ele1.props.web_use != 'undefined' &&
                                ele1.props.web_use != '' &&
                                ele1.props.web_use == ele1.props.web_endpoint
                            ) {
                                canAccess = true
                                return
                            } else if (
                                typeof ele1.props.web_use != 'undefined' &&
                                ele1.props.web_use == ''
                            ) {
                                canAccess = true
                                return
                            } else {
                                canAccess = false
                                return
                            }
                        }
                    })

                    if (canAccess) {
                        res = true
                        return
                    }
                })

                return res
            })

            resultChildren = resultChildren.map(ele => {
                let subChildren = ele && ele.props ? ele.props.children : undefined
                if (!Array.isArray(subChildren)) {
                    if (
                        ele &&
                        ele.type &&
                        typeof ele.type.isSubMenu != 'undefined' &&
                        ele.type.isSubMenu
                    ) {
                        subChildren = subChildren ? [subChildren] : []
                    } else if (
                        ele &&
                        ele.type &&
                        typeof ele.type.isMenuItem != 'undefined' &&
                        ele.type.isMenuItem
                    ) {
                        subChildren = [ele]
                    } else {
                        subChildren = []
                    }
                }

                subChildren = subChildren.filter(ele1 => {
                    if (hasIgnorePermission(ele1)) return true
                    let find = permissions.find(
                        ele2 =>
                            ele2.matching_name == ele1.props.matching_name &&
                            ele2.can_view == 1,
                    )

                    if (typeof find != 'undefined') {
                        if (
                            typeof ele1.props.web_use != 'undefined' &&
                            ele1.props.web_use != '' &&
                            ele1.props.web_use == ele1.props.web_endpoint
                        ) {
                            return true
                        } else if (
                            typeof ele1.props.web_use != 'undefined' &&
                            ele1.props.web_use == ''
                        ) {
                            return true
                        } else {
                            return false
                        }
                    }
                    return false
                })

                return {
                    ...ele,
                    props: {
                        ...ele.props,
                        children: subChildren,
                    },
                }
            })

            return (
                <Menu
                    mode="inline"
                    onClick={({ item, key, keyPath, selectedKeys, domEvent }) => {
                        this.props.handleActiveMenu(item.props.matching_name)
                    }}
                    openKeys={this.props.openKeysMenu}
                    onOpenChange={this.props.handleonOpenChange}
                >
                    <SubMenu
                        popupClassName="popup-menu-custom-set-width"
                        style={{
                            display: checkMenuVisibility(resultArr, permissions) && 'none',
                        }}
                        key={this.props.subkey}
                        title={this.props.title}
                    >
                        {resultChildren.map(ele => {
                            if (
                                typeof ele.type.isSubMenu != 'undefined' &&
                                ele.type.isSubMenu
                            ) {
                                // Inject external dynamic items into existing submenus (e.g. monitoring > video)
                                if (
                                    createExternalMenu &&
                                    ele &&
                                    ele.props &&
                                    ele.props.menu_hierarchy
                                ) {
                                    const rootMenuHierarchy = this.props.menu_hierarchy || ''
                                    const fullPath = rootMenuHierarchy
                                        ? `${rootMenuHierarchy} > ${ele.props.menu_hierarchy}`
                                        : ele.props.menu_hierarchy
                                    const extraChildren = React.Children.toArray(
                                        createExternalMenu(permissions, fullPath),
                                    )
                                    if (extraChildren.length > 0) {
                                        const currentChildren = React.Children.toArray(
                                            ele.props.children,
                                        )
                                        return React.cloneElement(ele, {
                                            children: currentChildren.concat(extraChildren),
                                        })
                                    }
                                }

                                return ele
                            } else if (
                                typeof ele.type.isMenuItem != 'undefined' &&
                                ele.type.isMenuItem
                            ) {
                                return ele.props.children
                            }
                        })}
                        {/* external link */}
                        {createExternalMenu
                            ? createExternalMenu(permissions, this.props.menu_hierarchy || '', {
                                  // prevent creating duplicate first-level groups that already exist as submenus
                                  skipNextSegments: resultChildren
                                      .filter(
                                          c =>
                                              c &&
                                              c.type &&
                                              typeof c.type.isSubMenu != 'undefined' &&
                                              c.type.isSubMenu &&
                                              c.props &&
                                              c.props.menu_hierarchy,
                                      )
                                      .map(c => c.props.menu_hierarchy),
                              })
                            : null}
                    </SubMenu>
                </Menu>
            )
        }
    }
}

export default { AutorizeMenu }
